// extracted by mini-css-extract-plugin
export default {"container":"Widget--container--fd1205"};